var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke-width: 1.5px;\n      }\n\n      .cls-2, .cls-3 {\n        stroke: #323232;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-3 {\n        stroke-width: 1.49px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.9,15.65l1.4.21c1.03.16,1.77,1.08,1.69,2.12l-.1,1.41c-.03.41.19.8.57.98l1.03.5c.37.18.81.11,1.12-.17l1.04-.96c.77-.71,1.95-.71,2.71,0l1.04.96c.3.28.75.35,1.12.17l1.04-.5c.37-.18.59-.56.56-.97l-.1-1.41c-.08-1.04.66-1.96,1.69-2.12l1.4-.21c.41-.06.74-.37.83-.77l.26-1.12c.09-.4-.07-.82-.41-1.05l-1.17-.8c-.86-.59-1.12-1.74-.6-2.65l.7-1.23c.21-.36.17-.8-.09-1.13l-.72-.9c-.26-.32-.68-.45-1.08-.33l-1.35.41c-1,.31-2.06-.21-2.45-1.18l-.52-1.31c-.15-.38-.52-.64-.94-.64h-1.15c-.41,0-.78.26-.93.64l-.51,1.3c-.38.98-1.45,1.49-2.45,1.19l-1.41-.43c-.4-.12-.83.01-1.08.34l-.71.9c-.26.32-.29.77-.08,1.13l.72,1.23c.53.91.27,2.07-.6,2.66l-1.15.79c-.34.23-.5.65-.41,1.05l.26,1.12c.09.4.42.71.83.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.01,18.27c0-1.58-1.27-2.86-2.84-2.86h-4.37c-1.57,0-2.84,1.28-2.84,2.86"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 12.17,
    cy: 10.99,
    r: 2.49
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManagement);
export default __webpack_public_path__ + "static/media/UserManagement.90d6a3aff09fd5ac4a17bf4661718eb0.svg";
export { ForwardRef as ReactComponent };